import Cookies from 'js-cookie';
import apiClient from 'services/_infra/apiClient';
import { tryCache } from 'services/_infra/requestCache';

export async function getHourlyForecast(limit) {
  try {
    const res = await tryCache(
      `getHourlyForecast-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post('/customWeatherCurHourlyForecast', {
          city: Cookies.get('city'),
          state: Cookies.get('state'),
          latitude: Cookies.get('latitude'),
          longitude: Cookies.get('longitude'),
        }),
    );
    return res;
  } catch (error) {
    console.error('customWeatherCurHourlyForecast failed.', error);
  }
}

export async function currentCityConditions() {
  try {
    const res = await tryCache(
      `currentCityConditions-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post('/getCurConditionsbyCity', {
          city: Cookies.get('city'),
          state: Cookies.get('state'),
          latitude: Cookies.get('latitude'),
          longitude: Cookies.get('longitude'),
        }),
    );
    return res;
  } catch (error) {
    console.error('getCurConditionsbyCity failed.', error);
  }
}

export async function getDetailedForecastData() {
  try {
    const res = await tryCache(
      `getDetailedForecastData-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post('/getDetailedForecastData', {
          city: Cookies.get('city'),
          state: Cookies.get('state'),
          longitude: Cookies.get('longitude'),
          latitude: Cookies.get('latitude'),
        }),
    );

    return res;
  } catch (error) {
    console.error('getDetailedForecastData failed.', error);
  }
}

export async function get15DayForecast() {
  try {
    const res = await tryCache(
      `get15DayForecast-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post('/customWeatherExt15', {
          city: Cookies.get('city'),
          state: Cookies.get('state'),
          latitude: Cookies.get('latitude'),
          longitude: Cookies.get('longitude'),
        }),
    );

    return res;
  } catch (error) {
    console.error('customWeatherExt15 failed.', error);
  }
}

export async function day7HourlyForecast() {
  try {
    const res = await tryCache(
      `day7HourlyForecast-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post(
          '/customWeather7DayHourlyForecast',
          {
            city: Cookies.get('city'),
            state: Cookies.get('state'),
            longitude: Cookies.get('longitude'),
            latitude: Cookies.get('latitude'),
          },
          {
            headers: {
              accessToken: Cookies.get('accessToken'),
              refreshToken: Cookies.get('refreshToken'),
            },
          },
        ),
    );
    return res;
  } catch (error) {
    console.error('customWeather7DayHourlyForecast failed.', error);
  }
}

export async function getAstronomyData() {
  try {
    const res = await tryCache(
      `getAstronomyData-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post('/getAstronomyData', {
          city: Cookies.get('city'),
          state: Cookies.get('state'),
          latitude: Cookies.get('latitude'),
          longitude: Cookies.get('longitude'),
        }),
    );
    return res;
  } catch (error) {
    console.error('getAstronomyData failed.', error);
  }
}

export async function getEarthquake() {
  try {
    const res = await tryCache('getEarthquake', () => apiClient.get('/getEarthQuake'));
    return res;
  } catch (error) {
    console.error('getEarthQuake failed.', error);
  }
}

export async function getHurricanesHistorical() {
  try {
    const res = await tryCache('getHurricanesHistorical', () =>
      apiClient.get('/getHurricanesHistorical'),
    );
    return res;
  } catch (error) {
    console.error('getHurricanesHistorical failed.', error);
  }
}

export async function getHurricanesLive() {
  try {
    const res = await tryCache('getHurricanesLive', () => apiClient.get('/getHurricanesLive'));
    return res;
  } catch (error) {
    console.error('getHurricanesLive failed.', error);
  }
}
